import Vue from "vue";
import Router from "vue-router";
import routerList from "@/router/views/index.js"
import Layout from "@/layout/index.vue"
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};
Vue.use(Router);
const routes = [
	{
        path: '/',
        component: Layout,
        redirect: '/index',
        title: '首页',
        name: '首页',
        children: [
			...routerList
		],
    },
	{
		path: '/login',
        component: Layout,
		redirect: '/login/index',
        title: '登录',
        name: '登录',
        children: [
			{
				path: '/login/index',
                name: 'login',
                meta: {
                    title: '登录',
                },
                component: () => import('@/views/login/index.vue'),
			}
		],
        
	},
	{
		path: '/register',
        component: Layout,
		redirect: '/register/index',
        title: '注册',
        name: '注册',
        children: [
			{
				path: '/register/index',
                name: 'register',
                meta: {
                    title: '注册',
                },
                component: () => import('@/views/register/index.vue'),
			}
		],
        
	},
]
// 实例化 Router 对象
const router = new Router({
	// linkActiveClass:'selected',
	routes,
	// mode: 'history'
	scrollBehavior(to, from, saveTop) {
		if (saveTop) {
			return saveTop;
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	}
})
// 路由拦截 在跳转之前
router.beforeEach((to, from, next) => {
	var type = sessionStorage.getItem('indexType')
	next()
})


export default router
